import { DateRangePeriod } from "../../../types";
import { getDictPhrase } from "../getDictPhrase";
const shouldNotAddPeriod = (key, config) => {
    return (DateRangePeriod[key] === DateRangePeriod.Last6Months && !config.includeLast6Months)
        || (DateRangePeriod[key] === DateRangePeriod.Last12Months && !config.includeLast12Months);
};
export const getDropDownOptions = (dict, config) => {
    let options = [];
    for (let key in DateRangePeriod) {
        if (isNaN(parseInt(key))) {
            if (shouldNotAddPeriod(key, config)) {
                continue;
            }
            options.push({ label: getDictPhrase(dict, key), value: key });
        }
    }
    return options;
};
//# sourceMappingURL=getDropDownOptions.js.map